'use client';
// Fire-and-forget client-side call to /api/city-demand-gap — see that route +
// lib/proMatching.ts for the full picture. Only call this when a match ACTUALLY
// expanded past the default radius or fell back to "everyone" — a normal in-radius
// match is not a gap and shouldn't be logged.
const _sent = new Set<string>();
export function logCityDemandGap(categorySlug: string, city: string, radiusKm: number | null, expanded: boolean, matchedCount: number): void {
  if (!expanded || !categorySlug || !city) return; // an incomplete report is not a gap (was a 400 on every category page, 2026-09-27)
  // one report per category×city per page view — two listeners (bar + list) used to send the same gap twice (re-verify N4)
  const key = `${categorySlug}|${city}`; if (_sent.has(key)) return; _sent.add(key);
  // …and once per day across tabs / reloads / Back (bughunter round 3 #5): a shared localStorage ledger
  try {
    const day = new Date().toISOString().slice(0, 10); const L = 'cityGapSent';
    const led = JSON.parse(localStorage.getItem(L) || '{}'); if (led.day !== day) { led.day = day; led.keys = []; }
    if (led.keys.includes(key)) return; led.keys.push(key); localStorage.setItem(L, JSON.stringify(led));
  } catch {}
  try {
    fetch('/api/city-demand-gap', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
      body: JSON.stringify({ categorySlug, city, radiusKm, expanded, matchedCount }),
    }).catch(() => {});
  } catch {}
}
